import { isString } from 'lodash';

export const getUploadData = (imageData, name) => {
  if (isString(imageData)) {
    return { file_url: imageData };
  }

  const formData = new FormData();
  formData.append('file', imageData, name || imageData.name);
  return formData;
};
